import React__default from 'react';
import seLogoWhiteBK from '../../../assets/se_logo_white.png.js';
import seLogoDarkBK from '../../../assets/SE_Logo_White_RGB.svg.js';

const Logo = ({ background = 'light', size = 'medium', onClick, alt, }) => {
    const params = {
        image: seLogoWhiteBK,
        height: 30,
    };
    switch (size) {
        case 'x-small':
            params.height = 20;
            break;
        case 'small':
            params.height = 25;
            break;
        case 'medium':
            params.height = 30;
            break;
        case 'large':
            params.height = 40;
            break;
        case 'x-large':
            params.height = 50;
            break;
        default:
            params.height = 30;
    }
    switch (background) {
        case 'light':
            params.image = seLogoWhiteBK;
            break;
        case 'dark':
            params.image = seLogoDarkBK;
            break;
        default:
            params.image = seLogoWhiteBK;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { style: { display: 'inline-block' }, onClick: onClick },
            React__default.createElement("img", { height: params.height, src: params.image, alt: alt }))));
};

export { Logo as default };
//# sourceMappingURL=Logo.js.map
